/* global window */

import Vue from 'vue';
import $ from 'jquery';

const notProduction = process.env.NODE_ENV !== 'production';

// initial state
const state = {
	transition: 'slide',
	transitionMode: '',
	showAppSub: true,
	isNavigating: false,
	scrollPosition: 0,
};

const getters = {
	getScrollPosition: (state) => {
		return state.scrollPosition;
	}
}

const actions = {
	setScrollPosition({commit}) {
		commit('updateData', {
			name: 'scrollPosition',
			value: window.pageYOffset,
		});
		$('html').addClass('no-scroll');
	},
	removeScrollPosition({state, commit}) {
		$('html').removeClass('no-scroll');
		window.scrollTo(0, state.scrollPosition);
		commit('updateData', {
			name: 'scrollPosition',
			value: 0,
		});
	}
}

// mutations
const mutations = {
	updateData(state, payload) {
		if (notProduction) {
			console.log(payload.name, payload.value);
		}
		Vue.set(state, payload.name, payload.value);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};


// WEBPACK FOOTER //
// ./assets/_js/store/modules/pages.js